import Svg, { Path } from 'react-native-svg'

const SettlementIcon = ({ width = 24, height = 24, color = '#000' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M19 5H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3ZM8 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm2 8H6a1 1 0 0 1-1-1 3 3 0 0 1 6 0 1 1 0 0 1-1 1Zm5-1a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0v2Zm4 0a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0v2Zm1-4.82a1 1 0 0 1-1 .82h-6a1 1 0 0 1-.35-1.94L15 8.18a2.76 2.76 0 0 1 2 0l2.37.88a1 1 0 0 1 .63 1.12Z"
    />
  </Svg>
)
export default SettlementIcon
